import React from 'react';
import {
  sortableContainer,
  sortableElement,
  sortableHandle
} from 'react-sortable-hoc';

export const DragHandle = sortableHandle(() => (
  <p style={{ cursor: 'pointer', color: '#999', margin: 0, paddingTop: '4px' }}>
    <i className="fa fa-bars"></i>
  </p>
));

export const SortableItem = sortableElement((props) => <tr {...props} />);
export const SortableContainer = sortableContainer((props) => (
  <tbody {...props} />
));
